import IntermediateLogin from './IntermediateLogin';

export default IntermediateLogin;



// WEBPACK FOOTER //
// ./src/pages/static/IntermediateLogin/index.jsx